<app-background-video></app-background-video>
<app-topbar></app-topbar>

<app-sidebar>
    <!-- Nothing to show here for now -->
</app-sidebar>

<div class="main-content">
    <div class="tile-box">
        <app-tile
            text="Shipping Operations"
            icon="../../assets/stevedoring.svg"
            link="/projects"
            [disabled]="!showShippingOperations"
        ></app-tile>

        <app-tile
            text="Web Storage"
            icon="../../assets/logistik.svg"
            link="/storage"
            [disabled]="!showStorage"
        ></app-tile>

        <app-tile
            text="Sustainability"
            icon="../../assets/transport.svg"
            link="/sustainability"
            [disabled]="!showSustainability"
        ></app-tile>

        <app-tile
            text="Terminal"
            icon="../../assets/terminal.svg"
            link="/terminal"
            [disabled]="!showTerminal"
        ></app-tile>

        <app-tile
            *ngIf="showUserAdmin"
            text="User Administration"
            icon="../../assets/agency.svg"
            link="/users"
        ></app-tile>
    </div>
    <div class="baeredygtighed">
        <a href="https://www.jut.dk/baeredygtighed/" target="_blank"><img src="../../assets/baeredygtighed.png"></a>
    </div>
</div>


